module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ordered":"Bestellt","period1":"Zeitraum 1","period2":"Zeitraum 2","suppliers":"Lieferanten","boothNumber":"Standnummer"},"en":{"ordered":"Ordered","period1":"Period 1","period2":"Period 2","suppliers":"Suppliers","boothNumber":"Booth number"}}')
  delete Component.options._Ctor
}
